import { navLinks } from "@/mocks/homeData";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 px-4 py-12 text-background-100 md:px-8 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-vip-crown-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">妖精视频</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              妖精视频写真福利专区，汇集高清写真集、福利图片与私拍美图，按类别整理女主写真合集，
              为喜欢收藏美图的用户提供清晰的浏览与筛选体验。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100">
                高清写真
              </span>
              <span className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100">
                私拍美图
              </span>
              <span className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100">
                每日更新
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wider text-accent-300">
              页面导航
            </h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.slice(0, 5).map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-200 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wider text-accent-300">
              更多内容
            </h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <a
                  href="#archive"
                  className="text-sm text-background-200 transition-colors hover:text-background-50"
                >
                  高清珍藏库
                </a>
              </li>
              <li>
                <a
                  href="#guide"
                  className="text-sm text-background-200 transition-colors hover:text-background-50"
                >
                  收藏指南
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-sm text-background-200 transition-colors hover:text-background-50"
                >
                  常见问题
                </a>
              </li>
              <li>
                <a
                  href="#subscribe"
                  className="text-sm text-background-200 transition-colors hover:text-background-50"
                >
                  订阅更新
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-50/10 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-200">
            © 2026 妖精视频写真集 · 内容仅供个人浏览与审美欣赏
          </p>
          <p className="text-xs text-background-200">
            请尊重拍摄者与模特的创作，勿用于商业用途
          </p>
        </div>
      </div>
    </footer>
  );
}